import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from '@app/app.config';

@Component({
  selector: 'app-left-panel',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.scss']
})
export class LeftPanelComponent implements OnInit {
  clientLogo?: string;
  clientName?: string;

  constructor(private config: AppConfig, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const clientId = this.route.snapshot.queryParams['client_id'];

    if (clientId) {
      void this.loadClientContext(clientId);
    }
  }

  private async loadClientContext(clientId: string): Promise<void> {
    const client = await this.config.loadClientContext(clientId);

    if (client) {
      this.clientName = client.name;
      this.clientLogo = client.alternateLogoUrl || client.logoUrl || undefined;
    }
  }
}
